export const slidesData = [
  {
    id: 1,
    url: "/images/slider_1.jpg",
    text: "news.rightContainer.feat1",
    box: "linear-gradient(360deg, #FC2EAD, #B10003)"
  },
  {
    id: 2,
    url: "/images/slider_2.jpg",
    text: "news.rightContainer.feat2",
    box: "linear-gradient(360deg, #FFD700, #B85B06)"
  },
  {
    id: 3,
    url: "/images/slider_3.jpg",
    text: "news.rightContainer.feat3",
    box: "linear-gradient(360deg, #41FEEC, #1955EF)"
  },
]